import React from 'react'
import { styled } from '@mui/material/styles'
import clsx from 'clsx'
import { Helmet } from 'react-helmet'
import axios from 'axios'
import Cookies from 'universal-cookie'
import md5Hex from 'md5-hex'
import { Card, CardMedia, CardContent, Grid, Box, AppBar, Toolbar } from '@mui/material'
import { Button, Checkbox, TextField, Avatar } from '@mui/material'
import { Typography, FormControlLabel, IconButton, InputAdornment, Chip, Collapse, CircularProgress } from '@mui/material'
import { Stepper, Step, StepContent } from '@mui/material'
import { AccountCircle, Visibility, VisibilityOff, Accessible } from '@mui/icons-material'
import { Badge } from '@mui/material'
import { Alert, AlertTitle } from '@mui/material'
import { indigo } from '@mui/material/colors'

import VerificaEstudiante from '../middlewares/VerificaEstudiante'

import LogoUTN from './images/logo_utn.svg'

const PREFIX = 'Login'
const classes = {
  root: `${PREFIX}-root`,
  navbar: `${PREFIX}-navbar`,
  iconosNavbar: `${PREFIX}-iconosNavbar`,
  logo: `${PREFIX}-logo`,
  label: `${PREFIX}-label`,
  carta: `${PREFIX}-carta`,
  titulo: `${PREFIX}-titulo`,
  textoCombobox: `${PREFIX}-textoCombobox`,
  img: `${PREFIX}-img`,
  margin: `${PREFIX}-margin`,
  textField: `${PREFIX}-textField`,
  botonLogin: `${PREFIX}-botonLogin`,
  botonOlvide: `${PREFIX}-botonOlvide`
}

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`& .${classes.root}`]: {
    '& .MuiPaper-root': {
      padding: 0,
    },
    '& .MuiStepContent-root': {
      marginTop: 'initial',
      marginLeft: 'initial',
      paddingLeft: 'initial',
      paddingRight: 'initial',
    },
    '& .MuiFormControlLabel-root' : {
      marginLeft: 'initial',
    },
  },
  [`& .${classes.navbar}`]: {
    backgroundColor: theme.palette.common.white,
    borderRadius: '0px 0 10px 10px',
  },
  [`& .${classes.iconosNavbar}`]: {
    fontSize: 30,
    color: indigo[900]
  },
  [`& .${classes.logo}`]: {
    marginRight: 7,
  },
  [`& .${classes.label}`]: {
    fontSize: '0.9rem'
  },
  [`& .${classes.carta}`]: {
    marginTop: 85,
    minWidth: 250,
    width: 500,
    border: '1px solid rgba(0, 0, 0, 0.50)',
    borderRadius: '20px',
  },
  [`& .${classes.titulo}`]: {
    flexGrow: 1,
    fontWeight: 'bolder',
    fontSize: '1.5rem',
    color: indigo[900]
  },
  [`& .${classes.textoCombobox}`]: {
    fontSize: '0.9rem'
  },
  [`& .${classes.img}`]: {
    objectFit: 'inherit',
    height: 120,
  },
  [`& .${classes.margin}`]: {
    margin: theme.spacing(1),
  },
  [`& .${classes.textField}`]: {
    width: '444px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  [`& .${classes.botonLogin}`]: {
    paddingTop: '100px',
    paddingRight: '15px',
    paddingBottom: '70px',
    paddingLeft: '15px',
  },
  [`& .${classes.botonOlvide}`]: {
    textTransform: 'initial',
  }
}))

const cookies = new Cookies()

function obtienePasos() {
  return ['ingreso_usuario']
}

export default function Login(props) {
  const t = global.t || {}
  //Se declaran los valores iniciales
  const [values, cargaValores] = React.useState({
    identificacion: cookies.get('_siguu') ? Buffer.from(cookies.get('_siguu'), 'base64').toString('ascii') : '',
    clave: '',
    mostrarClave: false,
    mensajeError: '',
    mensajeErrorAPI: '',
    mensajeAPI: '',
    intentos: 0,
    recordar: cookies.get('_siguu') ? true : false,
    ruta: props.match.params.id,
  })
  const [checked, cargaSeleccionado] = React.useState(values.recordar)
  const [activeStep, cargaPasoActual] = React.useState(0)
  const [, cargaMensaje] = React.useState(false)
  const [bloquearBoton, cargaEstadoBoton] = React.useState(false)

//Inicio del manejo de las acciones
  const steps = obtienePasos()

  const manejaSiguiente = () => {
    if (values.identificacion !== '') {
      values.mensajeError = ''
      cargaPasoActual((prevActiveStep) => prevActiveStep + 1)
    }
    else {
      values.mensajeError = t.T_FALTA_IDENTIFICACION || 'T_FALTA_IDENTIFICACION'
      cargaValores({ ...values, inputIdentificacion: values.mensajeError })
    }
  }

  const manejaOlvideClave = (event) => {
    event.preventDefault()
    cargaMensaje(false)
    values.mensajeError = ''
    const url = global.ApiUrl + '/restore'
    const querystring = require('querystring')
    axios.post(url, querystring.stringify(values), {
      withCredentials: true,
    })
    .then(response => {
      if ( response.status === 200 ) {
        values.mensajeAPI = response.data.body
        cargaMensaje(true)
        values.mensajeAPI = ''
      }
    })
    .catch(error => {
      values.mensajeErrorAPI = error.response.data.error
      cargaMensaje(true)
      values.mensajeErrorAPI = ''
      return
    })
  }

  const manejaLogin = (event) => {
    event.preventDefault()
    cargaMensaje(false)
    if (values.clave !== '') {
      cargaEstadoBoton(true)
      values.mensajeError = ''
      const url = global.ApiUrl + '/login'
      const valores = {identificacion: values.identificacion, clave: md5Hex(values.clave)}
      const querystring = require('querystring')
      axios.post(url, querystring.stringify(valores), {
        withCredentials: true,
      })
      .then(async(response) => {
        if ( response.status === 200 ) {
          cookies.set('_siguid', `Bearer ${response.data.token}`, { path: '/', secure:(process.env.REACT_APP_SEGURO === 'production' ? true: false), sameSite:(process.env.REACT_APP_SEGURO === 'production' ? 'Lax': ''), domain: process.env.REACT_APP_DOMINIO, maxAge: 15000 })
          await VerificaEstudiante(`Bearer ${response.data.token}`)
          if (values.recordar) {
            cookies.set('_siguu', Buffer.from(values.identificacion).toString('base64'), { path: '/', secure:(process.env.REACT_APP_SEGURO === 'production' ? true: false), sameSite:(process.env.REACT_APP_SEGURO === 'production' ? 'Lax': ''), domain: process.env.REACT_APP_DOMINIO, maxAge: 31536000 })
          }
          else {
            cookies.remove('_siguu', {path: '/', domain:process.env.REACT_APP_DOMINIO})
          }
          if (values.ruta) {
            if (/:ßÞßÞ/.test(values.ruta)) {
              window.location.href = `${values.ruta.replaceAll(':ßÞßÞ', process.env.REACT_APP_REDIRECT).replaceAll('ßÞ', '/')}`
            }
            else {
              window.location.href = `${process.env.REACT_APP_DASHBOARD}${values.ruta.replaceAll('ßÞ', '/')}`
            }
          }
          else {
            window.location.href = `${process.env.REACT_APP_DASHBOARD}/modulos`
          }
          return
        }
      })
      .catch(error => {
        if (!error.response) {
          values.mensajeErrorAPI = t.T_ERROR_500 || 'T_ERROR_500'
          values.intentos = 0
        }
        else {
          values.mensajeErrorAPI = error.response.data.error
          values.intentos = error.response.data.body
        }
        cargaEstadoBoton(false)
        cargaMensaje(true)
        values.mensajeErrorAPI = ''
        return
      })
    }
    else {
      values.mensajeError = t.T_FALTA_CONTRASENIA || 'T_FALTA_CONTRASENIA'
      cargaValores({ ...values, inputClave: values.mensajeError })
    }
  }

  const manejaReseteo = () => {
    values.mensajeError = ''
    values.intentos = 0
    cargaPasoActual(0)
  }

  const manejaTeclaEnter = (prop) => (event) => {

    if(event.key === 'Enter' && !bloquearBoton){
      prop === 'clave' ? manejaLogin(event) : manejaSiguiente()
    }
  }

  const manejaCambio = (prop) => (event) => {
    cargaValores({ ...values, [prop]: event.target.value })
  }

  const manejaCambioCombobox = (event) => {
    cargaSeleccionado(event.target.checked)
    values.recordar = event.target.checked
  }

  const manejaClickMostrarClave = () => {
    cargaValores({ ...values, mostrarClave: !values.mostrarClave })
  }

  const manejaMouseSobreClave = (event) => {
    event.preventDefault()
  }

  return (
    <StyledGrid container direction='row' justifyContent='center' alignItems='center'>
      <Helmet>Ingreso al sistema</Helmet>
      <AppBar position='fixed' className={classes.navbar}>
        <Toolbar>
          <Avatar className={classes.logo} style={{marginLeft: props.margen}} variant='rounded' alt='UTN logo' src={LogoUTN} />
          <Typography variant='h5' className={classes.titulo}>{t.T_SIGLAS_SISTEMA || 'T_SIGLAS_SISTEMA'}</Typography>
          <IconButton href={`${process.env.REACT_APP_DASHBOARD}/Accesibility`}>
            <Accessible className={classes.iconosNavbar} />
          </IconButton>
          <Box>
            <Button href={`${process.env.REACT_APP_DASHBOARD}${process.env.REACT_APP_PORTAL_PERFIL_REG_PAGE}`}>{t.T_CREAR_CUENTA || 'T_CREAR_CUENTA'}</Button>
            <Button href={process.env.REACT_APP_DASHBOARD}>{t.T_IR_PORTAL || 'T_IR_PORTAL'}</Button>
          </Box>
      </Toolbar>
      </AppBar>
      <Card className={clsx(classes.root, classes.carta)} elevation={6}>
        <CardMedia component='img' alt='Logo de la UTN' className={classes.img} image={LogoUTN} title='Logo UTN' />
        <CardContent>
          <Collapse in={values.mensajeErrorAPI !== '' ? true : false}>
            <Alert elevation={6} severity='error'>
              <AlertTitle>{t.T_ERROR_INGRESO || 'T_ERROR_INGRESO'}</AlertTitle>{values.mensajeErrorAPI}
            </Alert>
          </Collapse>
          <Collapse in={values.mensajeAPI !== '' ? true : false}>
            <Alert elevation={6} severity='success'>
              <AlertTitle>{t.T_CORRECTO || 'T_CORRECTO'}</AlertTitle>{values.mensajeAPI}
            </Alert>
          </Collapse>
          <Typography className={classes.titulo} color='primary' align='center' gutterBottom>{t.T_INICIAR_SESION || 'T_INICIAR_SESION'}</Typography>
          <Stepper activeStep={activeStep} orientation='vertical'>
            {steps.map((label) => (
              <Step key={label}>
                <StepContent>
                  <TextField autoFocus label={t.T_DIGITAR_IDENTIFICACION || 'T_DIGITAR_IDENTIFICACION'} id='inputIdentificacion' className={clsx(classes.margin, classes.textField)} value={values.identificacion} onKeyDown={manejaTeclaEnter('identificacion')} onChange={manejaCambio('identificacion')}
                    error={values.mensajeError !== ''} helperText={values.mensajeError !== '' ? values.mensajeError : ''}
                    inputProps={{ maxLength: 20 }}
                    InputProps={{
                      endAdornment: <InputAdornment position='end'><AccountCircle /></InputAdornment>,
                    }}
                    variant='outlined'
                  />
                  <FormControlLabel classes={{ label: classes.label }}
                    control={
                      <Checkbox checked={checked} onChange={manejaCambioCombobox} id='recordar' color='primary' />
                    }
                    label={t.T_RECORDAR_USUARIO || 'T_RECORDAR_USUARIO'}
                  />
                  <Grid container direction='row' justifyContent='flex-end' alignItems='flex-end' className={classes.botonLogin}>
                    <Button variant='contained' color='primary' onClick={manejaSiguiente} className={classes.button}> {t.T_SIGUIENTE || 'T_SIGUIENTE'}</Button>
                  </Grid>
                </StepContent>
              </Step>
            ))}
          </Stepper>
          {activeStep === steps.length && (
            <Grid container direction='row' justifyContent='center' alignItems='center'>
              <Badge badgeContent={values.intentos} color='error'>
                    <Chip icon={<AccountCircle />} label={values.identificacion} onClick={manejaReseteo} onDelete={manejaReseteo} variant='outlined' />
              </Badge>
              <TextField autoFocus label={t.T_CONTRASENIA || 'T_CONTRASENIA'} id='inputClave' className={clsx(classes.margin, classes.textField)} type={values.mostrarClave ? 'text' : 'password'} value={values.clave} onKeyDown={manejaTeclaEnter('clave')} onChange={manejaCambio('clave')}
                error={values.mensajeError !== ''} helperText={values.mensajeError !== '' ? values.mensajeError : ''}
                inputProps={{ maxLength: 128 }}
                InputProps={{
                  endAdornment:
                  <InputAdornment position='end'>
                    <IconButton aria-label={t.T_MOSTRAR_CONTRASENIA || 'T_MOSTRAR_CONTRASENIA'} onClick={manejaClickMostrarClave} onMouseDown={manejaMouseSobreClave} edge='end' size="large">
                      {values.mostrarClave ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }}
                variant='outlined'
              />
            </Grid>
          )}
          {activeStep === steps.length && (
            <Grid container direction='row' justifyContent='space-between' alignItems='center' className={classes.botonLogin}>
              <Button color='primary' className={classes.botonOlvide} onClick={manejaOlvideClave}>{t.T_OLVIDE_CONTRASENIA || 'T_OLVIDE_CONTRASENIA'}</Button>
              {!bloquearBoton &&
                <Button variant='contained' color='primary' onClick={manejaLogin} className={classes.button}>{t.T_INGRESAR || 'T_INGRESAR'}</Button>
              }
              {bloquearBoton &&
                <Typography variant='caption'><CircularProgress /> {t.T_VALIDANDO || 'T_VALIDANDO'}</Typography>
              }
            </Grid>
          )}
        </CardContent>
      </Card>
    </StyledGrid>
  )
}